// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let RelayEnv = require("../../../../RelayEnv.bs.js");
let RescriptRelay_Query = require("rescript-relay/src/RescriptRelay_Query.bs.js");
let Primitive_exceptions = require("@rescript/runtime/lib/js/Primitive_exceptions.js");
let MlsStatusQuery_graphql = require("../../../../__generated__/MlsStatusQuery_graphql.bs.js");

let convertVariables = MlsStatusQuery_graphql.Internal.convertVariables;

let convertResponse = MlsStatusQuery_graphql.Internal.convertResponse;

let convertWrapRawResponse = MlsStatusQuery_graphql.Internal.convertWrapRawResponse;

let use = RescriptRelay_Query.useQuery(convertVariables, MlsStatusQuery_graphql.node, convertResponse);

let useLoader = RescriptRelay_Query.useLoader(convertVariables, MlsStatusQuery_graphql.node, prim => prim);

let usePreloaded = RescriptRelay_Query.usePreloaded(MlsStatusQuery_graphql.node, convertResponse, prim => prim);

let fetch = RescriptRelay_Query.fetch(MlsStatusQuery_graphql.node, convertResponse, convertVariables);

let fetchPromised = RescriptRelay_Query.fetchPromised(MlsStatusQuery_graphql.node, convertResponse, convertVariables);

let retain = RescriptRelay_Query.retain(MlsStatusQuery_graphql.node, convertVariables);

let Query = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  use: use,
  useLoader: useLoader,
  usePreloaded: usePreloaded,
  fetch: fetch,
  fetchPromised: fetchPromised,
  retain: retain
};

async function queryFn(address, areaId) {
  let val;
  try {
    val = await fetchPromised(RelayEnv.environment, {
      input: {
        address: address,
        areaId: areaId
      }
    }, undefined, undefined);
  } catch (raw_e) {
    let e = Primitive_exceptions.internalToException(raw_e);
    return {
      TAG: "Error",
      _0: {
        NAME: "REJECTED",
        VAL: e
      }
    };
  }
  let response = val.validatePropertyMlsStatus;
  if (response === undefined) {
    return {
      TAG: "Error",
      _0: "INVALID_RESPONSE"
    };
  }
  if (response.__typename !== "PropertyMlsStatusValidated") {
    return {
      TAG: "Error",
      _0: "INVALID_RESPONSE"
    };
  }
  let mlsStatus = response.mlsStatus;
  if (mlsStatus !== undefined) {
    return {
      TAG: "Ok",
      _0: mlsStatus
    };
  } else {
    return {
      TAG: "Error",
      _0: "INVALID_RESPONSE"
    };
  }
}

exports.Query = Query;
exports.queryFn = queryFn;
/* use Not a pure module */
